import { array, Decoder, field, succeed } from 'jsonous';
import { linksDecoder } from '../../Resource/Decoders';
import { timeZoneDecoder } from '../../ProfileStore/Decoders';
import { TermsAndConditions, TermsAndConditionsResource } from '../Types';

const termsDecoder: Decoder<TermsAndConditions> = succeed({}).assign(
  'timeZoneOptions',
  field('time_zone_options', array(timeZoneDecoder)),
);

export const termsResourceDecoder: Decoder<TermsAndConditionsResource> = succeed({})
  .assign('payload', field('payload', termsDecoder))
  .assign('links', field('links', linksDecoder));
